import {
  Long2qws0ah9gnpki as Long,
  numberToLong1a4cndvg6c52s as numberToLong,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  VOID7hggqo3abtya as VOID,
  DurationUnit_MILLISECONDS_getInstancedq9xrzm1t8sm as DurationUnit_MILLISECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  compareTo3ankvs086tmwq as compareTo,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  equals2au1ep9vhcato as equals,
  Comparable198qfk8pnblz0 as Comparable,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  round2mrvepag8eey0 as round,
  DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance,
  Companion_getInstance148flmv2wtrla as Companion_getInstance,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  _Duration___get_inWholeNanoseconds__impl__r5x4mr3elpl3cwdan58 as _Duration___get_inWholeNanoseconds__impl__r5x4mr,
  DurationUnit_NANOSECONDS_getInstance2sujg77gnqrxb as DurationUnit_NANOSECONDS_getInstance,
  toDurationba1nlt78o6vu as toDuration_0,
  protoOf180f3jzyo7rfj as protoOf,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class Companion {
  constructor() {
    Companion_instance = this;
    this.h35_1 = new Long(1, 0);
    this.i35_1 = _DateTime___init__impl__ifgty2(0.0);
    this.j35_1 = 6.21355968E13;
  }
  k35(unix) {
    return _DateTime___init__impl__ifgty2(unix);
  }
  l35(unix) {
    return this.k35(unix.n4());
  }
  m35() {
    return _DateTime___init__impl__ifgty2(get_CoreTime().n35());
  }
  o35() {
    return numberToLong(get_CoreTime().n35());
  }
}
class DateTime {
  constructor(unixMillis) {
    Companion_getInstance_0();
    this.p35_1 = unixMillis;
  }
  q35(other) {
    return DateTime__compareTo_impl_geo3bs(this.p35_1, other);
  }
  d(other) {
    return DateTime__compareTo_impl_geo3bs_0(this, other);
  }
  toString() {
    return DateTime__toString_impl_cnueje(this.p35_1);
  }
  hashCode() {
    return DateTime__hashCode_impl_yf0bc9(this.p35_1);
  }
  equals(other) {
    return DateTime__equals_impl_qd7s8j(this.p35_1, other);
  }
}
class Companion_0 {
  r35() {
    return _FastDuration___init__impl__cfl6bz(0.0);
  }
  s35() {
    return _FastDuration___init__impl__cfl6bz(NaN);
  }
  t35() {
    return this.s35();
  }
}
class FastDuration {
  constructor(ms) {
    this.u35_1 = ms;
  }
  v35(other) {
    return FastDuration__compareTo_impl_4fhnj7(this.u35_1, other);
  }
  d(other) {
    return FastDuration__compareTo_impl_4fhnj7_0(this, other);
  }
  toString() {
    return FastDuration__toString_impl_c9xohb(this.u35_1);
  }
  hashCode() {
    return FastDuration__hashCode_impl_y13la6(this.u35_1);
  }
  equals(other) {
    return FastDuration__equals_impl_unk8ke(this.u35_1, other);
  }
}
class TimeProvider {}
class Companion_1 {
  m35() {
    return Companion_getInstance_0().m35();
  }
}
class ICoreTime {}
function performanceMillis() {
  return this.n35();
}
class CoreTime$1 {
  n35() {
    return Date.now();
  }
}
//endregion
function _DateTime___init__impl__ifgty2(unixMillis) {
  return unixMillis;
}
function _DateTime___get_unixMillis__impl__ofxkzp($this) {
  return $this;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new Companion();
  return Companion_instance;
}
function _DateTime___get_unixMillisDouble__impl__3dzlsc($this) {
  return _DateTime___get_unixMillis__impl__ofxkzp($this);
}
function _DateTime___get_unixMillisLong__impl__sdx9bd($this) {
  return numberToLong(_DateTime___get_unixMillisDouble__impl__3dzlsc($this));
}
function DateTime__minus_impl_10njw8($this, delta) {
  return _DateTime___init__impl__ifgty2(_DateTime___get_unixMillis__impl__ofxkzp($this) - get_milliseconds(delta));
}
function DateTime__minus_impl_10njw8_0($this, other) {
  // Inline function 'korlibs.time.milliseconds' call
  var this_0 = _DateTime___get_unixMillisDouble__impl__3dzlsc($this) - _DateTime___get_unixMillisDouble__impl__3dzlsc(other);
  return toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
}
function DateTime__compareTo_impl_geo3bs($this, other) {
  return compareTo(_DateTime___get_unixMillis__impl__ofxkzp($this), _DateTime___get_unixMillis__impl__ofxkzp(other));
}
function DateTime__compareTo_impl_geo3bs_0($this, other) {
  return DateTime__compareTo_impl_geo3bs($this.p35_1, other instanceof DateTime ? other.p35_1 : THROW_CCE());
}
function DateTime__toString_impl_cnueje($this) {
  return 'DateTime(' + _DateTime___get_unixMillisLong__impl__sdx9bd($this).toString() + ')';
}
function DateTime__hashCode_impl_yf0bc9($this) {
  return getNumberHashCode($this);
}
function DateTime__equals_impl_qd7s8j($this, other) {
  if (!(other instanceof DateTime))
    return false;
  var tmp0_other_with_cast = other instanceof DateTime ? other.p35_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function _FastDuration___init__impl__cfl6bz(ms) {
  return ms;
}
function _get_ms__ndc6g5($this) {
  return $this;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  return Companion_instance_0;
}
function _FastDuration___get_isNil__impl__n4fw9d($this) {
  return equals($this, Companion_instance_0.t35());
}
function _FastDuration___get_seconds__impl__4kvvav($this) {
  return _get_ms__ndc6g5($this) / 1000;
}
function _FastDuration___get_milliseconds__impl__ffr17u($this) {
  return _get_ms__ndc6g5($this);
}
function _FastDuration___get_microseconds__impl__o4j93h($this) {
  return _get_ms__ndc6g5($this) * 1000;
}
function _FastDuration___get_nanoseconds__impl__pxizcb($this) {
  return _get_ms__ndc6g5($this) * 1000000;
}
function _FastDuration___get_fastMilliseconds__impl__pe68va($this) {
  return _FastDuration___get_milliseconds__impl__ffr17u($this);
}
function _FastDuration___get_fastMicroseconds__impl__e641g1($this) {
  return _FastDuration___get_microseconds__impl__o4j93h($this);
}
function _FastDuration___get_fastNanoseconds__impl__9kjwbr($this) {
  return _FastDuration___get_nanoseconds__impl__pxizcb($this);
}
function FastDuration__plus_impl_q1enab($this, that) {
  return _FastDuration___init__impl__cfl6bz(_get_ms__ndc6g5($this) + _get_ms__ndc6g5(that));
}
function FastDuration__minus_impl_evs237($this, that) {
  return _FastDuration___init__impl__cfl6bz(_get_ms__ndc6g5($this) - _get_ms__ndc6g5(that));
}
function FastDuration__div_impl_rlslck($this, other) {
  return _get_ms__ndc6g5($this) / _get_ms__ndc6g5(other);
}
function FastDuration__times_impl_h6amcp($this, scale) {
  return _FastDuration___init__impl__cfl6bz(_get_ms__ndc6g5($this) * scale);
}
function FastDuration__div_impl_rlslck_0($this, scale) {
  return _FastDuration___init__impl__cfl6bz(_get_ms__ndc6g5($this) / scale);
}
function FastDuration__plus_impl_q1enab_0($this, other) {
  return _FastDuration___init__impl__cfl6bz(_FastDuration___get_milliseconds__impl__ffr17u($this) + get_milliseconds(other));
}
function FastDuration__minus_impl_evs237_0($this, other) {
  return _FastDuration___init__impl__cfl6bz(_FastDuration___get_milliseconds__impl__ffr17u($this) - get_milliseconds(other));
}
function FastDuration__compareTo_impl_4fhnj7($this, other) {
  return compareTo(_get_ms__ndc6g5($this), _get_ms__ndc6g5(other));
}
function FastDuration__compareTo_impl_4fhnj7_0($this, other) {
  return FastDuration__compareTo_impl_4fhnj7($this.u35_1, other instanceof FastDuration ? other.u35_1 : THROW_CCE());
}
function FastDuration__compareTo_impl_4fhnj7_1($this, other) {
  return compareTo(_get_ms__ndc6g5($this), get_milliseconds(other));
}
function FastDuration__toString_impl_c9xohb($this) {
  return 'FastDuration(ms=' + $this + ')';
}
function FastDuration__hashCode_impl_y13la6($this) {
  return getNumberHashCode($this);
}
function FastDuration__equals_impl_unk8ke($this, other) {
  if (!(other instanceof FastDuration))
    return false;
  var tmp0_other_with_cast = other instanceof FastDuration ? other.u35_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function get_fastSeconds(_this__u8e3s4) {
  return get_fastSeconds_0(_this__u8e3s4);
}
function toDuration_1(_this__u8e3s4) {
  return get_slow(_this__u8e3s4);
}
function get_fast(_this__u8e3s4) {
  var tmp;
  // Inline function 'korlibs.time.isNil' call
  if (equals(_this__u8e3s4, get_DURATION_NIL())) {
    tmp = Companion_instance_0.t35();
  } else {
    tmp = get_fastMilliseconds_0(get_milliseconds(_this__u8e3s4));
  }
  return tmp;
}
function get_fastMicroseconds(_this__u8e3s4) {
  return _FastDuration___init__impl__cfl6bz(_this__u8e3s4 / 1000);
}
function minus(_this__u8e3s4, other) {
  return _FastDuration___init__impl__cfl6bz(get_milliseconds(_this__u8e3s4) - _FastDuration___get_milliseconds__impl__ffr17u(other));
}
function get_fastMilliseconds(_this__u8e3s4) {
  return get_fastMilliseconds_0(_this__u8e3s4);
}
function roundMilliseconds(_this__u8e3s4) {
  return get_fastMilliseconds_0(round(_FastDuration___get_milliseconds__impl__ffr17u(_this__u8e3s4)));
}
function get_slow(_this__u8e3s4) {
  var tmp;
  if (_FastDuration___get_isNil__impl__n4fw9d(_this__u8e3s4)) {
    // Inline function 'korlibs.time.NIL' call
    Companion_getInstance();
    tmp = get_DURATION_NIL();
  } else {
    // Inline function 'korlibs.time.seconds' call
    var this_0 = _FastDuration___get_seconds__impl__4kvvav(_this__u8e3s4);
    tmp = toDuration(this_0, DurationUnit_SECONDS_getInstance());
  }
  return tmp;
}
function get_fastMilliseconds_0(_this__u8e3s4) {
  return _FastDuration___init__impl__cfl6bz(_this__u8e3s4);
}
function get_fastSeconds_0(_this__u8e3s4) {
  return _FastDuration___init__impl__cfl6bz(_this__u8e3s4 * 1000);
}
function get_fastMicroseconds_0(_this__u8e3s4) {
  return get_fastMilliseconds_0(_this__u8e3s4);
}
function div(_this__u8e3s4, other) {
  return get_milliseconds(_this__u8e3s4) / _FastDuration___get_milliseconds__impl__ffr17u(other);
}
function get_fastNanoseconds(_this__u8e3s4) {
  return _FastDuration___init__impl__cfl6bz(_this__u8e3s4 / 1000000);
}
function compareTo_0(_this__u8e3s4, other) {
  return compareTo(get_milliseconds(_this__u8e3s4), _FastDuration___get_milliseconds__impl__ffr17u(other));
}
function get_fastNanoseconds_0(_this__u8e3s4) {
  return get_fastMilliseconds_0(_this__u8e3s4);
}
var Companion_instance_1;
function Companion_getInstance_2() {
  return Companion_instance_1;
}
function get_DURATION_NIL() {
  _init_properties_TimeSpan_kt__xworpz();
  return DURATION_NIL;
}
var DURATION_NIL;
function get_milliseconds(_this__u8e3s4) {
  _init_properties_TimeSpan_kt__xworpz();
  return _Duration___get_inWholeNanoseconds__impl__r5x4mr(_this__u8e3s4).n4() / 1000000.0;
}
function get_seconds(_this__u8e3s4) {
  _init_properties_TimeSpan_kt__xworpz();
  return get_milliseconds(_this__u8e3s4) / 1000;
}
function max(a, b) {
  _init_properties_TimeSpan_kt__xworpz();
  // Inline function 'kotlin.time.Companion.milliseconds' call
  Companion_getInstance();
  // Inline function 'kotlin.math.max' call
  var a_0 = get_milliseconds(a);
  var b_0 = get_milliseconds(b);
  var this_0 = Math.max(a_0, b_0);
  return toDuration(this_0, DurationUnit_MILLISECONDS_getInstance());
}
var properties_initialized_TimeSpan_kt_fytdnd;
function _init_properties_TimeSpan_kt__xworpz() {
  if (!properties_initialized_TimeSpan_kt_fytdnd) {
    properties_initialized_TimeSpan_kt_fytdnd = true;
    DURATION_NIL = toDuration_0(new Long(13, -2097152), DurationUnit_NANOSECONDS_getInstance());
  }
}
function get_CoreTime() {
  _init_properties_CoreTime_js_kt__zee7g9();
  return CoreTime;
}
var CoreTime;
var properties_initialized_CoreTime_js_kt_73dge3;
function _init_properties_CoreTime_js_kt__zee7g9() {
  if (!properties_initialized_CoreTime_js_kt_73dge3) {
    properties_initialized_CoreTime_js_kt_73dge3 = true;
    CoreTime = new CoreTime$1();
  }
}
//region block: post-declaration
initMetadataForCompanion(Companion);
initMetadataForClass(DateTime, 'DateTime', VOID, VOID, [Comparable]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(FastDuration, 'FastDuration', VOID, VOID, [Comparable]);
initMetadataForInterface(TimeProvider, 'TimeProvider');
initMetadataForCompanion(Companion_1, VOID, [TimeProvider]);
initMetadataForInterface(ICoreTime, 'ICoreTime');
protoOf(CoreTime$1).w35 = performanceMillis;
initMetadataForClass(CoreTime$1, VOID, VOID, VOID, [ICoreTime]);
//endregion
//region block: init
Companion_instance_0 = new Companion_0();
Companion_instance_1 = new Companion_1();
//endregion
//region block: exports
export {
  DateTime__hashCode_impl_yf0bc9 as DateTime__hashCode_impl_yf0bc92s64omsn0fynv,
  DateTime__minus_impl_10njw8_0 as DateTime__minus_impl_10njw812puhhvc4b9kf,
  DateTime__minus_impl_10njw8 as DateTime__minus_impl_10njw81qwhaqtma3616,
  DateTime__toString_impl_cnueje as DateTime__toString_impl_cnueje2ackcuvowzg0n,
  FastDuration__compareTo_impl_4fhnj7 as FastDuration__compareTo_impl_4fhnj72c084ut3ho50d,
  FastDuration__compareTo_impl_4fhnj7_1 as FastDuration__compareTo_impl_4fhnj73optjj2wg605h,
  FastDuration__div_impl_rlslck as FastDuration__div_impl_rlslck3eqcfgtjve915,
  FastDuration__div_impl_rlslck_0 as FastDuration__div_impl_rlslck2moqkr2wlhp55,
  _FastDuration___get_fastMicroseconds__impl__e641g1 as _FastDuration___get_fastMicroseconds__impl__e641g11wrcl3xo4cr7g,
  _FastDuration___get_fastMilliseconds__impl__pe68va as _FastDuration___get_fastMilliseconds__impl__pe68va81p5t8ucvnk8,
  _FastDuration___get_fastNanoseconds__impl__9kjwbr as _FastDuration___get_fastNanoseconds__impl__9kjwbr3nvm3csqkttdd,
  FastDuration__hashCode_impl_y13la6 as FastDuration__hashCode_impl_y13la6nym0c1xbwjaa,
  _FastDuration___get_microseconds__impl__o4j93h as _FastDuration___get_microseconds__impl__o4j93h2rn63lkq7a8kl,
  _FastDuration___get_milliseconds__impl__ffr17u as _FastDuration___get_milliseconds__impl__ffr17unfwkaxi4cy42,
  FastDuration__minus_impl_evs237_0 as FastDuration__minus_impl_evs237bt7zqxxnwet,
  FastDuration__minus_impl_evs237 as FastDuration__minus_impl_evs237rhg84spop2c8,
  _FastDuration___get_nanoseconds__impl__pxizcb as _FastDuration___get_nanoseconds__impl__pxizcb1ry8wyoc0dr5c,
  FastDuration__plus_impl_q1enab as FastDuration__plus_impl_q1enab1plpz0e6mgxzj,
  FastDuration__plus_impl_q1enab_0 as FastDuration__plus_impl_q1enab30y5opwsu5po5,
  _FastDuration___get_seconds__impl__4kvvav as _FastDuration___get_seconds__impl__4kvvavkn2srn5t4e0w,
  FastDuration__times_impl_h6amcp as FastDuration__times_impl_h6amcp3u6kv4tju4mnx,
  FastDuration__toString_impl_c9xohb as FastDuration__toString_impl_c9xohb3u75ye94mx1dw,
  Companion_getInstance_0 as Companion_getInstance36wz4kh9aujgq,
  Companion_instance_0 as Companion_instance293l0r179rei7,
  Companion_instance_1 as Companion_instance3gshkh79a96f7,
  get_CoreTime as get_CoreTime23yr4od90u6o9,
  get_DURATION_NIL as get_DURATION_NIL2lkiawowwp1us,
  DateTime as DateTime2gld4ho36azq9,
  FastDuration as FastDuration3d3pupg2e5ora,
  TimeProvider as TimeProvider2j6wl2le6n0p3,
  compareTo_0 as compareTo2tbidk88xyn1w,
  div as div1s6t4x2ts64sh,
  get_fast as get_fast37cu8s8qwnuyi,
  get_fastMicroseconds_0 as get_fastMicroseconds16wth98xujxdo,
  get_fastMicroseconds as get_fastMicroseconds3xewe49ldi5s,
  get_fastMilliseconds as get_fastMilliseconds2pmoifl74b2oz,
  get_fastMilliseconds_0 as get_fastMillisecondsfxaeyfzoedsj,
  get_fastNanoseconds_0 as get_fastNanoseconds1laeiegsk8vcx,
  get_fastNanoseconds as get_fastNanosecondsibv7lnrlu50o,
  get_fastSeconds as get_fastSecondsxsf72e0ltu4j,
  get_fastSeconds_0 as get_fastSeconds3ld6xqdi008l3,
  max as max1q2oylvn6uire,
  get_milliseconds as get_milliseconds20vru1dkca6bq,
  minus as minus2npwq73u0d9yx,
  roundMilliseconds as roundMilliseconds3bd2pntxev66o,
  get_seconds as get_secondsjblpw5qd4dzj,
  get_slow as get_slowaqovrrnrezzv,
  toDuration_1 as toDuration15w5sljvx2ut2,
};
//endregion
